import { StyleSheet } from 'aphrodite';
import {
	aceGray,
	borderColor,
	brandPrimaryHover,
	brandPrimaryText,
	darkGrayFontColor,
} from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	cell: {
		padding: 10,
	},
	companyLink: {
		':hover': {
			color: brandPrimaryHover,
		},
		color: brandPrimaryText,
		cursor: 'pointer',
		display: 'inline-block',
		fontSize: 16,
		fontWeight: 600,
		textDecoration: 'none',
		whiteSpace: 'nowrap',
	},
	containerSelected: {
		backgroundColor: '#F2F6F8',
	},
	creationDateSpan: {
		color: darkGrayFontColor,
		fontSize: 14,
	},
	extraTags: {
		backgroundColor: 'white',
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		boxShadow: '0px 2px 4px rgba(157, 160, 174, 0.4)',
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: 8,
		maxWidth: 300,
		maxHeight: 300,
		overflowY: 'auto',
		overflowX: 'hidden',
		padding: 8,
		'::-webkit-scrollbar': {
			background: 'transparent',
			width: 10,
			borderRadius: 8,
		},
		'::-webkit-scrollbar-thumb': {
			backgroundColor: aceGray,
			borderRadius: 10,
			padding: '0 2px',
			width: 6,
		},
	},
	infoLink: {
		':hover': {
			color: brandPrimaryText,
			textDecoration: 'none',
		},
		color: aceGray,
		fontSize: 14,
		textDecoration: 'none',
	},
	infoPopover: {
		backgroundColor: 'white',
		border: `1px solid ${borderColor}`,
		borderRadius: 3,
		boxShadow: '0px 2px 4px rgba(157, 160, 174, 0.4)',
		padding: 10,
	},
	nameColumn: {
		cursor: 'pointer',
		display: 'flex',
		fontWeight: 'bold',
		gap: 10,
		height: 30,
		alignItems: 'center',
	},
	subtitle: {
		color: aceGray,
		fontSize: 14,
		marginTop: 4,
	},
	tag: {
		marginRight: 0,
		display: 'flex',
	},
	tagMore: {
		cursor: 'pointer',
	},
	tagsColumn: {
		display: 'flex',
		flexWrap: 'nowrap',
		whiteSpace: 'nowrap',
		gap: 8,
	},
});
